import { HighlightedRow } from "api/other/models";
import { UUID } from "api/types";
import { InvoicePagination } from "components/common/invoicePagination/InvoicePagination";
import { CommonError, RightPanelHandler } from "components/utils";
import { RightPanel } from "./rightPanel/RightPanel";
import { ListDrawerWrapper } from "components/utils/drawer";
import { Loader } from "components/utils/loader";
import { ModuleList } from "components/utils/moduleList";
import { ModuleListBody } from "components/utils/moduleList/components/ModuleListBody";
import { ModuleListHeader } from "components/utils/moduleList/components/ModuleListHeader";
import { manufacturingSchemasListConfig } from "components/utils/moduleList/utils/moduleListConfig";
import { NoResults } from "components/utils/noResults";
import { useQuery, useToggle } from "hooks";
import { useState } from "react";
import { handleMultipleRowsHighlight } from "utilities/handleMultipleRowsHighlight";
import { ListItem } from "./components/ListItem";
import { getSearch } from "./utils/getSearch";
import { ListHeader } from "./components/ListHeader";
import { useProductsLightQuery } from "api/products/hooks";

export const ProductsList = () => {
  const { query } = useQuery({ exclude: ["panelId"] });
  const search = getSearch({ query });
  const { data: products, error, isLoading, pagination } = useProductsLightQuery(search);
  const createManufacturingSchemaModal = useToggle(false);
  const [highlightedRows, setHighlightedRows] = useState<HighlightedRow[]>([]);

  const noResults = !products.length && !isLoading && !error;

  if (error) {
    return (
      <div>
        <ListHeader open={createManufacturingSchemaModal.open} />
        <div className="mt-4">
          <CommonError status={error._httpStatus_} />
        </div>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div>
        <Loader module="inventory" />
        <ListHeader open={createManufacturingSchemaModal.open} />
      </div>
    );
  }

  const selectMutlipleItems = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
    id: UUID | number,
    index: number,
    togglePanel: () => void,
  ) => {
    handleMultipleRowsHighlight(
      event,
      highlightedRows,
      id,
      index,
      setHighlightedRows,
      togglePanel,
      products,
    );
  };

  return (
    <div className="pageContainer">
      <ListHeader open={createManufacturingSchemaModal.open} />
      <RightPanelHandler name="products">
        {({ close, isActive, isHighlighted, togglePanel }) => (
          <ListDrawerWrapper>
            {noResults ? (
              <NoResults on={noResults} subHeader="zamówienia" />
            ) : (
              <ModuleList>
                <ModuleListHeader
                  gridStyle={manufacturingSchemasListConfig.grid}
                  labels={manufacturingSchemasListConfig.labels}
                />
                <ModuleListBody>
                  {products.map((product, index) => (
                    <ListItem
                      highlightedRows={highlightedRows}
                      index={index}
                      isActive={isActive}
                      isHighlighted={isHighlighted}
                      key={product.id}
                      product={product}
                      selectMutlipleItems={selectMutlipleItems}
                      togglePanel={togglePanel}
                      search={search}
                    />
                  ))}
                </ModuleListBody>
              </ModuleList>
            )}
            <RightPanel close={close} />
            <InvoicePagination pagination={pagination} />
          </ListDrawerWrapper>
        )}
      </RightPanelHandler>
    </div>
  );
};
